import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Input, Grid, Button } from '../../components';
import { trataMensagensErro } from '../../utils/requests';

class FiltroExtratoCnis extends Component {
  constructor() {
    super();
    this.filtroExtratoCnis = JSON.parse(sessionStorage.getItem('FiltroExtratoCnis'));

    this.state = {
      nitFiltro: this.filtroExtratoCnis && this.filtroExtratoCnis.nitFiltro ?
        this.filtroExtratoCnis.nitFiltro : null,
      elosFiltro: this.filtroExtratoCnis && this.filtroExtratoCnis.elosFiltro ?
        this.filtroExtratoCnis.elosFiltro : null,
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem('filtroExtratoCnis')) {
      this.handleSearchButton();
    }
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.tipoConsulta !== prevProps.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  preparaNovaConsulta = () => {
    let filtroExtratoCnis = {
      nitFiltro: null,
      elosFiltro: null,
    };

    filtroExtratoCnis = JSON.stringify(filtroExtratoCnis);
    sessionStorage.setItem('filtroExtratoCnis', filtroExtratoCnis);

    this.setState({
      nitFiltro: null,
      elosFiltro: null,
    });
  }

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  handleSearchButton = () => {
    let filtroExtratoCnis = {
      nitFiltro: this.state.nitFiltro,
      elosFiltro: this.state.elosFiltro,
    };
    filtroExtratoCnis = JSON.stringify(filtroExtratoCnis);
    sessionStorage.setItem('filtroExtratoCnis', filtroExtratoCnis);
    this.handleSearch();
  }

  handleSearch = () => {
    // if (((this.state.elosCnis === null || this.state.elosCnis === '') &&
    // (this.state.nitCnis === null || this.state.elosCnis === '')) ||
    // ((this.state.elosCnis !== null && this.state.elosCnis !== '') &&
    // (this.state.nitCnis === null || this.state.nitCnis === ''))) {
    if (((this.state.elosCnis !== null && this.state.elosCnis !== '') && (this.state.nitCnis === null || this.state.nitCnis === ''))) {
      trataMensagensErro(['É necessário digitar um nit para o elo digitado.']);
    } else {
      this.props.handleSearchFilter(this.state);
    }
  }

  montaFiltros() {
    return (
      <React.Fragment>
        <div className="row">
          <Grid cols="3 3 3 3">
            <Input
              integer
              label="Nit principal"
              value={this.state.nitCnis}
              onChange={e => this.handleChange(e, 'nitCnis')}
              maxlength="11"
            />
          </Grid>
          <Grid cols="9 9 9 9">
            <Input
              label="Elos (separados por vírgulas)"
              value={this.state.elosCnis}
              onChange={e => this.handleChange(e, 'elosCnis')}
              nitElado
            />
          </Grid>
        </div>
      </React.Fragment>
    );
  }

  render() {
    const filtrosPesquisa = this.montaFiltros();
    if (!filtrosPesquisa) {
      return null;
    }
    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="pesquisa"
          panelId="filtro-pesquisa"
          icon="ico-filter"
          title="Filtro de Pesquisa"
        >
          {filtrosPesquisa}
          <div className="row">
            <Button
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearchButton()}
              hint="Pesquisar de acordo com o filtro aplicado"
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}

FiltroExtratoCnis.propTypes = {
  handleChangeList: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  list: PropTypes.array,
}.isRequired;

export default FiltroExtratoCnis;



// WEBPACK FOOTER //
// ./src/pages/consultas/FiltroExtratoCnis.jsx